<template>
  <div>
    <h4 class="font-weight-bold text-center pb-3">Reset Password</h4>
    <b-form v-if="!resetSuccess" @submit.prevent="onSubmit" novalidate>
      <div class="mb-3">Please enter the email address associated to your FOResT account.</div>
      <ValidationObserver ref="observer">
        <b-form-row class="mb-3">
          <b-col>
            <ValidationProvider name="Email" rules="required" v-slot="{ errors, classes }">
              <b-form-input
                type="email"
                id="email"
                name="email"
                v-model="email"
                placeholder="Email"
                autocomplete="email"
                :class="classes"
                :aria-describedby="$errorsIdString(errors, 'email')"
              />
              <InputErrors :errors="errors" errorsIdPrefix="email" />
            </ValidationProvider>
          </b-col>
        </b-form-row>
      </ValidationObserver>
      <b-button type="submit" variant="outline-primary" pill block :disabled="submitting" aria-label="Send Reset Password Email">
        Send Reset Password Email
      </b-button>
    </b-form>
    <b-alert v-else variant="success" show>
      Please check your email for instructions to reset your password.
    </b-alert>
  </div>
</template>


<script>
import FormSubmit from '@/mixins/FormSubmit';

export default {
  name: 'ResetPasswordForm',
  mixins: [FormSubmit],
  data() {
    return {
      email: '',
      resetSuccess: false,
    };
  },
  methods: {
    async onSubmit() {
      this.submit(this.$refs.observer, 'User/sendPasswordReset', this.$data);
    },
    submitSuccess() {
      this.resetSuccess = true;
    },
  },
};
</script>
